import { Styles, css, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  root: ({ theme, props }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    text-align: center;
    padding: 24px 0;
    gap: 24px;
    border-top: ${props.showDivider ? `1px solid ${theme.colors.neutral.variant[20]}` : 'none'};
  `,
  links: css`
    display: flex;
    align-items: center;
    gap: 2px;
  `,
  poweredBy: css`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
  `,
  rootPoweredByOnly: css`
    padding-top: 0;
    border-top: none;
    gap: 0;
  `,
  footerMessage: css`
    display: flex;
    flex-direction: column;
    align-items: center;
  `,
} satisfies Styles<{ readonly showDivider: boolean }>;

export const useStyles = withStyles(styles);
